import { createSlice } from '@reduxjs/toolkit';
import { RootState } from './store';

const enumsSlice = createSlice({
  name: 'enumsData',
  initialState: {
    enums: {} as any,
  },
  reducers: {
    setEnums: (state, action) => {
      state.enums = action.payload;
    },
  },
});

export const { setEnums } = enumsSlice.actions;
export const getEnumsData = (state: RootState) => state.enumsSlice;
export const getAppointmentStatus = (state: RootState) => {
  const status: any = {};

  state.enumsSlice.enums.appointment_status_enums?.forEach((item: any) => {
    switch (item.value) {
      case '0':
        status.NEW = item.value;
        break;
      case '1':
        status.PENDING = item.value;
        break;
      case '2':
        status.CONFIRMED = item.value;
        break;
      case '3':
        status.CANCELLED = item.value;
        break;
      case '4':
        status.NEXT = item.value;
        break;
      case '5':
        status.PREVIOUS = item.value;
        break;
      default:
        break;
    }
  });

  return status;
};

export const getQuestionBasicTypes = (state: RootState) => {
  const type: any = {};

  state.enumsSlice.enums.basic_question_enums?.forEach((item: any) => {
    switch (item.value) {
      case '0':
        type.NAME = item.value;
        break;
      case '1':
        type.PHONE = item.value;
        break;
      case '2':
        type.EMAIL = item.value;
        break;
      default:
        break;
    }
  });

  return type;
};

export const getSurveyQuestionTypes = (state: RootState) => {
  const type: any = {};

  state.enumsSlice.enums.survey_question_types_enums?.forEach((item: any) => {
    switch (item.value) {
      case '0':
        type.SMALL_TEXT = item.value;
        break;
      case '1':
        type.NUMBER = item.value;
        break;
      case '2':
        type.CHOOSE = item.value;
        break;
      case '3':
        type.MULTIPLE_CHOICES = item.value;
        break;
      case '4':
        type.DATE = item.value;
        break;
      case '5':
        type.BIG_TEXT = item.value;
        break;
      case '6':
        type.DROPDOWN = item.value;
        break;
      case '7':
        type.PHONE = item.value;
        break;
      default:
        break;
    }
  });

  return type;
};
export const getFormQuestionTypes = (state: RootState) => {
  const type: any = {};

  state.enumsSlice.enums.form_question_type_enums?.forEach((item: any) => {
    switch (item.value) {
      case '0':
        type.SMALL_TEXT = item;
        break;
      case '1':
        type.BIG_TEXT = item;
        break;
      case '2':
        type.NUMBER = item;
        break;
      case '3':
        type.CHOOSE = item;
        break;
      case '4':
        type.SELECT = item;
        break;
      case '5':
        type.PHONE = item;
        break;
      case '6':
        type.EMAIL = item;
        break;
      default:
        break;
    }
  });

  return type;
};

export const getNumberConditionTypes = (state: RootState) => {
  const type: any = {};

  state.enumsSlice.enums.condition_number_enums?.forEach((item: any) => {
    switch (item.value) {
      case '0':
        type.EQUAL = item;
        break;
      case '1':
        type.NOT_EQUAL = item;
        break;
      case '2':
        type.LESS_THAN = item;
        break;
      case '3':
        type.LESS_THAN_OR_EQUAL = item;
        break;
      case '4':
        type.GREATER_THAN = item;
        break;
      case '5':
        type.GREATER_THAN_OR_EQUAL = item;
        break;
      case '6':
        type.RANGE = item;
        break;
      case '7':
        type.NOT_IN_RANGE = item;
        break;
      default:
        break;
    }
  });

  return type;
};

export const getTextConditionTypes = (state: RootState) => {
  const type: any = {};

  state.enumsSlice.enums.condition_text_enums?.forEach((item: any) => {
    switch (item.value) {
      case '0':
        type.EQUAL = item;
        break;
      case '1':
        type.NOT_EQUAL = item;
        break;
      case '2':
        type.CONTAINS = item;
        break;
      case '3':
        type.NOT_CONTAINS = item;
        break;
      case '4':
        type.EMPTY = item;
        break;
      case '5':
        type.NOT_EMPTY = item;
        break;
      default:
        break;
    }
  });

  return type;
};

export const getSingleSelectConditionTypes = (state: RootState) => {
  const type: any = {};

  state.enumsSlice.enums.condition_single_select_enums?.forEach((item: any) => {
    switch (item.value) {
      case '0':
        type.EQUAL = item;
        break;
      case '1':
        type.NOT_EQUAL = item;
        break;
      default:
        break;
    }
  });
  return type;
};

export default enumsSlice.reducer;
